import React from 'react';
import ProjectAI from '@/components/app/ProjectAI';
import { useLang } from '@/context/LangContext';

export default function AIPage() {
    const { t } = useLang();
    return (
        <div className="space-y-6">
            <div>
                <div className="eyebrow mb-2">Assistant IA</div>
                <h1 className="font-heading text-4xl">{t('ai.title')}</h1>
            </div>
            <ProjectAI projectId={null} project={null} />
        </div>
    );
}
